module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "ct1",
    attrs: {
      "id": "pz27-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#aa_04",
      "id": "bb_04"
    }
  }, [_vm._v("TWO")])]), _vm._v(" "), _c('h1', {
    staticClass: "ct2"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#aa_04"
    }
  }, [_c('b', [_vm._v("FORGIVENESS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pz27-2"
    }
  }, [_vm._v("An air of fear that had hung over Charleston for a day was blown out to sea with the quick arrest of a suspect. Behind it rushed in the urgent curiosity to discover who Dylann Roof was and why he had committed this shocking deed that was quickly labeled a hate crime. Fate had handed the church such a horrific tragedy—not just for the nine souls who died but also for the five who were destined to survive it—and everyone wanted, "), _c('i', [_vm._v("needed")]), _vm._v(", answers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz27-3"
    }
  }, [_vm._v("Roof had been named a suspect before noon on the day after the shooting. A nationwide police bulletin warned the suspect was armed, dangerous, and should be approached with caution. Later that day Roof was captured in Shelby, North Carolina, a three-and-a-half-hour drive northwest of Charleston. His older sister, Amber Roof, lived there with her fiancé. Roof was cooperative as he was searched, handcuffed, and arrested. A gun was found in the car. Roof was allowed to exit his vehicle before he was frisked. He was also casually escorted to a police cruiser and allowed to step into the backseat of the vehicle under his own power. After police took him to a local lockup, he announced he was hungry. Police got him a Burger King meal. Social media reacted to a perceived "), _c('span', {
    attrs: {
      "id": "z28-1"
    }
  }, [_vm._v("double standard in Roof’s treatment that was in stark contrast to the rough handling of numerous black suspects, particularly twenty-five-year-old Freddie Gray in Baltimore, Maryland, who was unrestrained in a fast-moving police van in April 2015, during which he suffered a fatal spinal cord injury.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz28-2"
    }
  }, [_vm._v("Roof did not challenge his return to South Carolina. He was flown back to Charleston on a state-owned plane that evening under very tight security, then placed in the Charleston County Detention Center in North Charleston. He was confined in a cell near Michael Slager, the former North Charleston police officer who was charged with murder in the April 4, 2015, death of fifty-four-year-old Walter Scott, an unarmed black North Charleston resident who was shot in the back. The day after Roof’s arrest, nine families were preparing to get their first answers about the tragedy that had been visited upon them.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "images/img-28-1.jpg",
      "src": "images/img-28-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "pz28-4"
    }
  }, [_vm._v("Ethel Lance fussed over the appearance of the historic Emanuel sanctuary. For three decades as the church’s custodian, she’d taken pride in keeping the church spotless. Lance’s daughter Esther said that if her mother “saw a scuff on the floor she’d say, ‘Oh no, don’t ya’ll mess up my floor.’ ”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_1_04",
      "id": "ff_1_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" At one time her duties even extended a block down Calhoun Street, where she’d worked as a custodian at the Gaillard Municipal Auditorium from its opening in 1968 until her retirement in 2002.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz28-5"
    }
  }, [_vm._v("Ethel Lance’s personality mirrored her attention to detail in everything, especially her family. She was a doting but no-nonsense protector of seven grandchildren and four great-grandchildren. Esther Lance said her seventy-year-old mother was a “strong” woman. “If she saw something wrong, she’ll tell you. When you right, you’re right. But if you’re wrong, she will let you know. She’s not going to sugar-coat anything.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_2_04",
      "id": "ff_2_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz28-6"
    }
  }, [_vm._v("Ethel Lance and her husband, Nathaniel Lance, raised their family "), _c('span', {
    attrs: {
      "id": "z29-1"
    }
  }, [_vm._v("in Charleston’s West Ashley suburb. Following his death in 1988, Ethel took over as matriarch. Of her five children, all but one is alive; cancer claimed her daughter Terrie Washington at age fifty-three in 2013. At Ethel’s funeral, Terrie’s daughter, Najee Washington, said her mother’s and grandmother’s reunion in heaven filled her with “pure joy.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_3_04",
      "id": "ff_3_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz29-2"
    }
  }, [_vm._v("Ethel was the cousin of Susie Jackson, also slain at the church. Eighty-seven years old, Susie was a church trustee and choir member. She had two children of her own, but she opened her Alexander Street home, located not far from the church, to everyone who needed a meal or shelter. Like Ethel, Susie also was the matriarch of her family. “She was a loving person, she never had no animosity toward nobody,” said Susie’s son, Walter Jackson of Cleveland, Ohio. Susie Jackson had raised her son in a government-funded housing project on the city’s east side, near the church. When Walter moved away, she opened the bedroom to two youngsters who needed a home. “She took in others,” Walter Jackson said of his mother. “She was just that type of person.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_4_04",
      "id": "ff_4_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz29-3"
    }
  }, [_vm._v("In a single flash of gun violence, Susie was one of three people snatched from her family. The other was twenty-six-year-old Tywanza Sanders, Susie Jackson’s nephew. He tried to save his aunt’s life, but was instead gunned down too. Sanders was a barber in North Charleston, an aspiring rapper and actor, poet, motivational speaker, and entrepreneur. In 2014, he earned a business administration degree from Allen University, an AME-supported, four-year institution in Columbia, South Carolina.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz29-4"
    }
  }, [_vm._v("A regular at Columbia’s open-mic poetry night, Mind Gravy, Sanders would skateboard down to the Five Points neighborhood almost every Wednesday night from the Allen campus. He was known for his humility and was well-liked and respected in poetry circles. Unlike many young people’s work, full of anger, his performance poems were always thoughtful. According to Mind Gravy director Al Black, “Tywanza was almost like a sixties poet” in terms of tone and subject matter."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_5_04",
      "id": "ff_5_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz30-1"
    }
  }, [_vm._v("The tall Sanders had a captivating smile that placed those around him at ease and snagged him a role in a play being rehearsed at a local Baptist church, recalled North Charleston cast member Nowa Fludd. Sanders had been teased by female members of the cast for not dating regularly. Playwright Hortense Mitchell, who recruited Sanders for her play "), _c('i', [_vm._v("Life")]), _vm._v(", was surprised by his response. He didn’t want a relationship until he had something to offer."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_6_04",
      "id": "ff_6_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz30-2"
    }
  }, [_vm._v("Emanuel’s property committee was guided by its chairwoman, Myra Thompson. She was in the midst of restoring church-owned properties, and with a smaller project completed, her attention was turning to the structural needs of the church. The fifty-nine-year-old mother, retired schoolteacher, and pastor’s wife had her license to preach in the AME Church renewed the night she died in her house of faith. As a teacher, Thompson worked up to the end in the church where she’d grown up. She led the Bible study session where a stranger among them was welcomed to sit and listen.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz30-3"
    }
  }, [_vm._v("Rev. Simmons may have been in the best position to stop the shooter. The veteran had a license to carry a gun, but the weapon was in his car. Simmons had returned decades before from Vietnam with a Purple Heart. Soon he entered another service, the ministry, and led three AME churches in the Mount Pleasant community east of Charleston. After three decades in those pulpits, he joined Emanuel’s ministerial staff, its spiritual heart. He was a regular at Bible study.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz30-4"
    }
  }, [_vm._v("Simmons was as tough as a drill sergeant though he had a smile that could be seen a mile away. He was born in Clarendon County, one of the counties that make up South Carolina’s impoverished stretch of communities along Interstate 95 dubbed the “Corridor of Shame.” He was a fourth-generation preacher. After serving in the US Army, Simmons graduated from Allen University and later earned master’s degrees in social work from the University of South Carolina and divinity from Lutheran Seminary. During the shooting, he was wounded, then rushed "), _c('span', {
    attrs: {
      "id": "z31-1"
    }
  }, [_vm._v("to the Medical University Hospital, where he died. He was the last of the victims to be laid to rest.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz31-2"
    }
  }, [_vm._v("Rev. DePayne Middleton-Doctor sang in the church choir and had preached at AME and Baptist churches in the Charleston area. This forty-nine-year-old mother of four girls had retired in 2005, as director of the Charleston County Community Development Block Grant Program. The year before her death, she had become an admissions coordinator for the Charleston learning center of Southern Wesleyan University."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_7_04",
      "id": "ff_7_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Middleton-Doctor’s best friend and kindred spirit, Jackie Starks, will never forget her friend’s voice. “So angelic it could move the very depth of your heart . . . How do you describe an angel?”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_8_04",
      "id": "ff_8_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz31-3"
    }
  }, [_vm._v("Rev. Sharonda Coleman-Singleton, a speech pathologist, was also the girls’ track coach at Goose Creek High School, a campus in Berkeley County, South Carolina. She encouraged her runners to give their best with sweet endearments, such as “suga’ pie” or just plain “suga.” She was on Emanuel’s ministerial staff. Coleman-Singleton, a New Jersey native, was the forty-five-year-old mother of three, including her eldest son, Chris Singleton, a baseball player at Charleston Southern University. At a prayer vigil on the CSU campus, Chris Singleton said, “My mom was a God-fearing woman. And she loved everybody with all her heart.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_9_04",
      "id": "ff_9_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz31-4"
    }
  }, [_vm._v("In the block east of Emanuel stands the main branch of the Charleston County Public Library (CCPL). The death of fellow librarian Cynthia Graham Hurd shook her colleagues deeply. A Charleston native, Hurd was a lover of books who enjoyed a thirty-one-year career with the library system; her life was divided between the church and the library. For more than two decades, beginning in 1990, she had been branch manager of the John L. Dart Branch, located in a predominantly African American community on Charleston’s peninsula. Later she was promoted to manager of a regional branch in the St. Andrews community west of Charleston. The CCPL has voted to rename that branch in her honor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz31-5"
    }
  }, [_vm._v("Hurd, who had five siblings, grew up in Mother Emanuel. Her "), _c('span', {
    attrs: {
      "id": "z32-1"
    }
  }, [_vm._v("brother, former North Carolina state senator Malcolm Graham, said, “The church is home to us,” adding that when their mother passed away fifteen years ago, Cynthia “took over the role of mother. She was the one who brought us together.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_10_04",
      "id": "ff_10_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" She died four days shy of her fifty-fifth birthday. She is survived by her husband, Arthur Stephen Hurd, a merchant seaman who was at sea near Saudi Arabia when his wife was murdered.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz32-2"
    }
  }, [_vm._v("At age thirteen, Clementa Carlos Pinckney was called to preach in the AME Church. At age eighteen, he was named pastor of his own church. At twenty-three, he was elected (in 1996) to the South Carolina House of Representatives from Jasper County, becoming the youngest African American elected to the legislature. Four years later he was elected to the South Carolina Senate. In 2010, he was appointed Emanuel’s pastor. The forty-one-year-old Pinckney had fought hard for the people from his senatorial district on several issues, including Medicaid funding, voting rights access, and police body cameras.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz32-3"
    }
  }, [_vm._v("In the late 1990s, when Pinckney was pursuing a master’s in public administration at the University of South Carolina, he interned at the Department of Mental Health’s division of quality improvement with Mary Catherine Adams, a trained nurse. That was during the time Pinckney was elected to the House of Representatives. Adams and others from the office attended his swearing-in ceremony. “I’ve had a lot of interns, but he stood out,” she remembers. “At such a young age, Clementa was mature, kind, and genuine, and professional without being pretentious.” Pinckney chose to intern at the mental health agency because it was a subject he didn’t know enough about. Adams continues, “When he died, it was disbelief. It was sickening—and to find out how it happened. But to know, people were so forgiving. For me, as a Southern woman, it is difficult to understand how someone could have that much racial hatred. I have seen it before, but to think someone would enter a church and take lives like that. For a mental illness, we have medications. You can’t medicate for someone’s hatred.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_11_04",
      "id": "ff_11_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz33-1"
    }
  }, [_vm._v("Pinckney was a quiet, humble man with a rich baritone voice that boomed across a room; it drew people to his side. His associate and friend Sen. Vincent Sheheen referred to him as the voice for the voiceless."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_12_04",
      "id": "ff_12_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Others called him the Senate’s moral compass. Pinckney’s district includes parts of six counties, about the size of Rhode Island, that touch the southern portion of the “Corridor of Shame,” a zone where social and political issues set the tone for his legislative agenda. In a 2010 interview, Pinckney said, “Loving God is never separate from loving our brothers and sisters. It’s always the same.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_13_04",
      "id": "ff_13_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz33-2"
    }
  }, [_vm._v("Those killed by the assailant’s gunfire have come to be known as the Emanuel Nine. However, five other members of the congregation were in the church the night bullets riddled the room where they held Bible study. One bullet pierced the wall of the pastor’s office, where Pinckney’s wife, Jennifer Pinckney, and the couple’s youngest daughter, Malana, were hiding. In the Bible study room, the killer was unaware Felicia Sanders and her granddaughter were alive on the hard tile floor in pools of warm blood. As the gunman prepared to leave, he paused at Polly Sheppard’s feet, where she was hiding under a long folding table. He told her, “I am going to let you live so you can tell the story of what happened.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_14_04",
      "id": "ff_14_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "images/img-28-1.jpg",
      "src": "images/img-28-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "pz33-4"
    }
  }, [_vm._v("The gray-block detention center where Roof was being held is adjacent to a courtroom where he appeared for a bond hearing on nine counts of murder and one charge of possession of a weapon during the commission of a violent crime."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_15_04",
      "id": "ff_15_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" Roof was wrapped in a bulletproof vest as two sheriff’s department deputies, also wearing body protection, escorted him to a tiny room equipped with a video camera and monitor. On the screen Roof could see and hear Charleston County chief magistrate James Gosnell. Roof may have unknowingly found a kindred spirit in the judge, who was a Civil War reenactor and who had once used the word "), _c('i', [_vm._v("nigger")]), _vm._v(" in the courtroom."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_16_04",
      "id": "ff_16_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz34-1"
    }
  }, [_vm._v("Before the hearing began, Gosnell announced he wanted to read a statement to the audience in the packed courtroom and those who watched the live news coverage. “Charleston is a very strong community. We have big hearts. We are a very loving community, and we are going to reach out to everyone, all victims, and will touch them. We have victims; nine of them. But we also have victims on the other side. There are victims on this young man’s side of the family,” he said, gesturing for emphasis. “Nobody would have thrown them into the whirlwind of events that they have been thrown into. We must find it in our heart at some point in time not only to help those that are victims but to also help his family as well.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_17_04",
      "id": "ff_17_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" The judge’s remarks received criticisms as unwarranted and bordering on grandstanding during a high-profile court case.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz34-2"
    }
  }, [_vm._v("Roof’s family had a response to the tragedy. Through his attorneys, public defender Ashley Pennington of Charleston and Boyd Young of Columbia, they offered their sympathies with hopes and prayers for healing nationwide."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_18_04",
      "id": "ff_18_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz34-3"
    }
  }, [_vm._v("Some of the relatives of the nine people who died spoke at the bond hearing, offering surprising and unexpected sentiment. They spoke directly to the suspect. Roof stood motionless and silent through the thirteen-minute hearing. He answered, “Yes, sir,” to questions from the judge about his address, age, and to affirm he was unemployed. Roof could not see the relatives of those who died, but he could hear their voices shake with emotion and rise with emphasis.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz34-4"
    }
  }, [_vm._v("Nadine Collier, Ethel Lance’s daughter, spoke with a quivering voice. “I just want everybody to know, to you [Roof], I forgive you. You took something really precious away from me.” Her voice rose in tone and emphasis as she said, “I will never talk to her ever again. I will never be able to hold her again, but I forgive you and have mercy on your soul. You hurt me. You hurt a lot of people, but I forgive you.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_19_04",
      "id": "ff_19_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz34-5"
    }
  }, [_vm._v("Myra Thompson’s husband, Anthony Thompson, vicar of Holy Trinity Reformed Episcopal Church in downtown Charleston, told the "), _c('span', {
    attrs: {
      "id": "z35-1"
    }
  }, [_vm._v("defendant: “I forgive you, my family forgives you, but we would like for you to take this opportunity to repent, repent, confess and give your life to the one who matters the most—Christ—so he can change it, he can change your ways no matter what happens to you and you will be okay. Do that and you will be better off than you are right now.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_20_04",
      "id": "ff_20_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz35-2"
    }
  }, [_vm._v("Felicia Sanders, Tywanza Sanders’s mother, added similar sentiments. “We welcomed you Wednesday night in our Bible study with open arms.” Those who died, she told Roof, were some of the most beautiful people she knew. Some sobbed softly as she spoke. “Every fiber in my body hurts, and I will never be the same. Tywanza Sanders was my son, but Tywanza was my hero . . . May God have mercy on you.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_21_04",
      "id": "ff_21_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz35-3"
    }
  }, [_vm._v("Simmons’s granddaughter, Alana Simmons, said, “Although my grandfather and the other victims died at the hands of hate, this is proof—everyone’s plea for your soul is proof that they lived and loved, and their legacies will live and love so hate won’t win. And I just want to thank the court for making sure that hate does not win.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_22_04",
      "id": "ff_22_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz35-4"
    }
  }, [_vm._v("Bethane Middleton-Brown, Middleton-Doctor’s sister, expressed a similar thought. “For me I am a work in progress, and I acknowledge that I am very angry,” she said with heavy emotion. “But one thing that DePayne has always joined in our family with is that she taught me that we are the family that love built. We have no room for hate so we have to forgive. I pray God on your soul, and I also thank God that I won’t be around when your judgment day comes with him.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_23_04",
      "id": "ff_23_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz35-5"
    }
  }, [_vm._v("The judge’s invitation to speak on behalf of Coleman-Singleton, Hurd, and Pinckney was not taken up.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "images/img-28-1.jpg",
      "src": "images/img-28-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "pz35-7"
    }
  }, [_vm._v("Church member Marguerite Michel didn’t attend the bond hearing but watched it on television from her modest home two miles north of the city’s thriving historic district. Each Sunday Michel headed in that "), _c('span', {
    attrs: {
      "id": "z36-1"
    }
  }, [_vm._v("direction for service at Emanuel, which she joined at age sixteen, just two years before a Wall Street crash triggered the Great Depression. She was the church’s oldest member at age 104. Marguerite Michel died February 13, 2016. She was buried in the Emanuel cemetery.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz36-2"
    }
  }, [_vm._v("Michel was in the audience for the televised eulogistic service of Emanuel’s beloved pastor, Clementa Pinckney, attended by President Obama, who delivered a rousing and emotional eulogy and warmed the nation’s heart with his rendition of “Amazing Grace.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz36-3"
    }
  }, [_vm._v("“I love my God. Look how he brought me through. He didn’t have to bring me this far,” Michel said. “I ask him every day, if I have done anything [wrong], please forgive. Please forgive me.” Although she sought forgiveness from the Creator for unbeknownst transgressions, she would be hard-pressed to forgive the suspect who took the life of nine people she loved. “I don’t know about that [forgiveness]. Nine people gone. I am trying to figure it out. You don’t come to church to hurt people. You come to church to help and to love one another. How can you say you love God and hate the people you see in the church?”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_24_04",
      "id": "ff_24_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz36-4"
    }
  }, [_vm._v("Michel said she was close to those who were slain, but perhaps she was closest to Ethel Lance and Susie Jackson through their shared experiences with the church’s senior citizens program.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz36-5"
    }
  }, [_vm._v("After Sunday services Myra Thompson sometimes tested Michel’s memory.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz36-6"
    }
  }, [_vm._v("“She would tease her all the time,” Michel’s youngest daughter, Ferrel Greene, recalled.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz36-7"
    }
  }, [_vm._v("“Do you remember me?” Thompson would ask.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz36-8"
    }
  }, [_vm._v("Michel would counter, “Who are you?”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_25_04",
      "id": "ff_25_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz36-9"
    }
  }, [_vm._v("Michel not only appreciated the span of her existence on earth but Emanuel’s existence as a church. On the wall behind her chair hangs a painting of Emanuel, labeled with milestone dates: 1818 and 1891."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_26_04",
      "id": "ff_26_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" She witnessed some of the church’s most historic moments. She was in the dimly lit sanctuary the night Martin Luther King Jr. preached to an "), _c('span', {
    attrs: {
      "id": "z37-1"
    }
  }, [_vm._v("overflowing audience swaying side to side with arms linked as they sang “We Shall Overcome.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_27_04",
      "id": "ff_27_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz37-2"
    }
  }, [_vm._v("Michel remembered fondly Reverend Benjamin James Glover, who had led the young people in the church during sit-in demonstrations to break segregated lunch counters in the city’s business district. While she didn’t participate in those marches, years later in 1969, she joined with striking black nurses at the then Medical College of South Carolina, who were protesting for more than just higher wages. They were demanding to be treated with the respect that was afforded to white nurses."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_28_04",
      "id": "ff_28_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz37-3"
    }
  }, [_vm._v("Now Emanuel is at another historic crossroads. The church has been a target of hate before, dating back to its burning following Denmark Vesey’s failed slave conspiracy in 1822 (see "), _c('span', {
    attrs: {
      "href": "#/chapter08#bb_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 6")]), _vm._v("). Church members say hate will not win over evil, but it is difficult to understand the source of this modern-day hatred from a suspect who is only twenty-one years old. Surely he has not lived long enough to harbor so much deep-seated hatred. This white man, who sought to ignite a race war, is now accused of killing nine black people at a prominent and historic AME church in Charleston, the cradle of slavery. Several factors seem to have aligned to suggest the suspect was an astute and deranged student of history or, perhaps, just an unfortunate and unwitting agent of fate.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz37-4"
    }
  }, [_vm._v("Following Roof’s arrest authorities learned more about him. A racist manifesto that authorities said was written by Roof was released to the media. It had appeared on a website that purportedly belonged to him. In it he said, “I have no choice. I am not in the position to, alone, go into the ghetto and fight. I chose Charleston because it is ["), _c('i', [_vm._v("sic")]), _vm._v("] most historic city in my state and at one time had the highest ratio of blacks to Whites in the country. We have no skinheads, no real KKK, no one doing anything but talking on the internet ["), _c('i', [_vm._v("sic")]), _vm._v("]. Well someone has to have the bravery to take it to the real world, and I guess that has to be me.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_29_04",
      "id": "ff_29_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz37-5"
    }
  }, [_vm._v("Roof is remembered by some former neighbors as the strange, bug-eyed boy with a bowl haircut who helped with yard work in rural "), _c('span', {
    attrs: {
      "id": "z38-1"
    }
  }, [_vm._v("Lexington County. Some can’t fathom how he learned to have such deep resentment toward people of African descent. Weeks before his arrest Roof had told friends he wanted to do “something big,” and he had plans to commit a mass shooting at the College of Charleston. Another friend remembered that Roof wasn’t mean, but he had “a darkness to his life.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_30_04",
      "id": "ff_30_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" These are contrary statements about a young man with no record of violence, who has remained largely silent aside from the website.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz38-2"
    }
  }, [_vm._v("In 1994, Dylann Roof was born to Amelia “Amy” Cowles Roof and Franklin Bennett “Benn” Roof, who had divorced three years earlier. They attempted to rebuild their marriage, but it failed. Dylann lived with his mother.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz38-3"
    }
  }, [_vm._v("In November 1999, when Dylann was five, his father, a construction contractor, married Paige Mann (they would file for divorce a decade later). Paige and Benn had a comfortable life, with expensive vehicles and a three-thousand-square-foot, custom-built home in the Earlewood area of Columbia. They had four other properties—one of which was a house in the Florida Keys, where they lived for a time, but Dylann Roof apparently never attended school there. Neighbors did not see him often, but they do recall he was small for his age."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_31_04",
      "id": "ff_31_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz38-4"
    }
  }, [_vm._v("Paige Mann, Dylann’s stepmother, cared for him while his father was away from home for as many as four days a week. Her stepson, she says, was “a loner and quiet and very smart—too smart. He was locked in his room looking up bad stuff on the computer. Something on the computer drew him in—this is Internet evil.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_32_04",
      "id": "ff_32_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz38-5"
    }
  }, [_vm._v("After the Roofs returned separately to South Carolina in late 2008, a foreclosure claimed the house in the Keys; then Benn Roof’s construction business failed. Paige alleged that abuse led her to leave her husband; meanwhile a private detective gave Benn proof that his wife was cheating on him. The breakup of his father’s marriage occurred as Dylann Roof was entering the ninth grade in Lexington, South Carolina, where he had previously attended fourth and eighth grades. School officials there "), _c('span', {
    attrs: {
      "id": "z39-1"
    }
  }, [_vm._v("described him as a “very transient student.” His home life was just as transient. Dylann Roof often alternated living in Lexington—a rural, mostly white community west of Columbia—where his mother lived, to Columbia, where his father owned real estate."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_33_04",
      "id": "ff_33_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz39-2"
    }
  }, [_vm._v("But what happened to shape Dylann Roof’s attitudes about race? As a shy fifth grader in Columbia, Roof was in school with black students, but he was not able to click with the “in” crowd. Two years later, in the seventh grade, Roof showed little evidence of racial hatred, Caleb Brown, a childhood friend, remembered. Roof had a close relationship with Brown, a mixed-race boy, at the urging of the boys’ mothers. Brown and Roof met as part of a class project that required students to ask their parents about their heritage. Roof asked the curly-haired and dark-skinned Brown about his lineage, and he was told that Brown’s father was black. It didn’t change the way Roof treated Brown. While they were pals, Roof didn’t have a wide circle of friends."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_34_04",
      "id": "ff_34_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz39-3"
    }
  }, [_vm._v("As a middle schooler Roof began losing interest in academics, which had become boring. Roof also frequently complained that his father put him to work landscaping—probably to keep him busy and out of trouble—but in an interview with the "), _c('i', [_vm._v("New York Times")]), _vm._v(", Roof’s friends said he had become more interested in smoking grass than cutting it. By the time he got to high school, his father’s marriage had imploded, and Roof was distracted from school, a pursuit he’d already lost interest in; he repeated the ninth grade. In 2010, he finished the last three months of his second chance at the ninth grade in Columbia, but from that point no records for Roof were found at schools in Columbia or Lexington."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_35_04",
      "id": "ff_35_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz39-4"
    }
  }, [_vm._v("Years later Roof does show up in criminal records. At a local shopping mall in February 2015, he unsettled employees of a business by asking store employees about the number of people working in the business and what time they would leave. The fact that he was dressed in black contributed to the feeling of unease, and the police were called. A police officer searched Roof and found a prescription drug, Suboxone, "), _c('span', {
    attrs: {
      "id": "z40-1"
    }
  }, [_vm._v("which treats opiate addiction. He was charged with a misdemeanor and was barred from the mall for a year. Another police officer questioned Roof a few weeks later about loitering at a park. Semiautomatic rifle parts were found in his car’s trunk, but no charges were filed. About this same time—just weeks before the attack at Emanuel—Roof was arrested at the same shopping mall and convicted of misdemeanor trespassing; he received an extended three-year ban.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz40-2"
    }
  }, [_vm._v("In late spring of 2015, Roof purchased a .45-caliber handgun from a West Columbia gun store with money his father had given him for his twenty-first birthday; it was the weapon he allegedly used to kill the Emanuel Nine. Following the Emanuel shooting, the FBI noted that a criminal background check should have prevented Roof from buying the weapon because he had admitted to drug possession in February."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_36_04",
      "id": "ff_36_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz40-3"
    }
  }, [_vm._v("From a shy schoolboy, Dylann Roof grew to become a young man who purchased a weapon to kill human beings. In the hours after the shooting, his paternal grandparents, Joseph and Lucy Roof, expressed sincere grief and were visibly upset. According to one of their neighbors, “They said they were going to stay prayed up and ask the Lord to help them through this. A lot of people feel children . . . are taught intolerance and discrimination. I don’t feel that is something Joe Roof would have taught or tolerated. Someone had to teach [Dylann Roof] that.” Another family acquaintance said Dylann Roof’s father and grandfather both live in neighborhoods with African American neighbors and that when Benn Roof held parties, he often invited his black and Hispanic employees."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_37_04",
      "id": "ff_37_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" Though none of this sheds light on where Dylann Roof learned to hate, his website told the story of a racist young man. “Integration has done nothing but bring Whites down to the level of brute animals,” he wrote. It included pictures of him with patches from white-ruled African nations on his clothing and another of him with the Confederate flag. His clothing also was adorned with the number 88—a reference to the white supremacist code for “Heil Hitler.” Police reported that on "), _c('span', {
    attrs: {
      "id": "z41-1"
    }
  }, [_vm._v("Roof’s website, he posted a nearly twenty-five-hundred-word essay on black crime, with reference to the white supremacist group Council of Conservative Citizens."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_38_04",
      "id": "ff_38_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz41-2"
    }
  }, [_vm._v("The racial rhetoric that might have been absent from Roof’s speech before he dropped out of the ninth grade began to appear when he was reunited with childhood friends via social media. In 2015, he joined Facebook and contacted Kimberly Konzny’s sons, his friends in Lexington. Roof spent several nights a week sleeping on Konzny’s sofa, watching movies. Because he had a car and pocket money, he chauffeured his friends and provided bottles of domestic vodka. Twenty-year-old Joseph C. Meek Jr., Konzny’s older son, was quoted as saying that after he reconnected with Roof, he found Roof to be “a lot more quiet. He was, like, emotionless.” Meek’s fifteen-year-old brother, Jacob, said Roof “doesn’t use the N-word. He says ‘African-American.’ ”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_39_04",
      "id": "ff_39_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" But Joseph Meek revealed that he knew Roof talked about doing “something big” and that he was prone to have racist views—although Meek didn’t attempt to inform police. He didn’t know then that Roof wanted to start a race war. “He wanted it to be white with white, and black with black . . . He had it in his mind, and he didn’t really let nobody know (what he was going to do),” Meek said."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_40_04",
      "id": "ff_40_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz41-3"
    }
  }, [_vm._v("Although Roof did occasionally make racist statements, he was not linked with any particular racial groups, so Meek didn’t take him seriously. But after Roof said on June 10 that in seven days he wanted to carry out a mass shooting at the College of Charleston, Meek and another friend, who is an African American, took Roof’s gun from his car and hid it. They had been drinking vodka, and Meek hid the handgun until they all sobered up. Meek returned the weapon after another friend became concerned that Meek should not have it while he was on probation."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_41_04",
      "id": "ff_41_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz41-4"
    }
  }, [_vm._v("After a search began for a suspect, Carson Cowles, Roof’s maternal uncle, called police to identify his nephew. “The whole world is going to be looking at his family who raised this monster,” Cowles said."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_42_04",
      "id": "ff_42_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" “He’s guilty as hell. He’ll get no sympathy from us, any of us.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter18#nn_43_04",
      "id": "ff_43_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7c7e56c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter04.vue
// module id = 81
// module chunks = 0